




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore,
} from "@root/lib/decorator";
import ProductAttrSelect from "@/components/custom/productAttrSelect/index.vue";
import SetStorePurchaseDisplayDialog from "./setStorePurchaseDisplayDialog.vue";

const common = namespace("common");
const order = namespace("order");
const scan = namespace("scan");
const wt = namespace("wt");
@Component({ components: { ProductAttrSelect, SetStorePurchaseDisplayDialog } })
@pagination("getData", {
  pageSize: 50,
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class InventoryQuery extends Vue {
  @scan.State patternList; // 花纹
  @scan.State hubDiameterList; // 轮毂直径
  @scan.State flattenList; // 扁平率
  @scan.State sectionWidthList; // 断面宽
  @scan.Action queryStoreViewInventoryStatus;
  @scan.Action updateStoreViewInventoryStatus;

  // @scan.State dataList;

  @common.Action queryDataDictionaryListLang;
  @scan.Action getAttr;
  @scan.Action querySupplierCount;
  @scan.Action exportSupplierCount;
  @wt.Action queryBrandList;
  @scan.Action queryLastFiveYearsWithMerge;
  @scan.Action getOrgSupplierCountQuantity;

  private form = {
    brand: "",
    specification: "",
    patternList: [],
    hubDiameter: "",
    flatten: "",
    sectionWidth: "",
    figure: "",
    spec: "",
  };
  private dataList = [];
  private priceBrandList = [];

  private patternDataList = [];
  private specificationList = [];
  private isShowExportDialog = false;
  private tableSearchForm = {};

  tableYearList: any = [];
  totalAmount: any = "";

  get orderListComputed() {
    return this.dataList || [];
  }

  async created() {
    // await this.getAttrApi();
    // await this.getBrandList();
    // this.getTableYearList();
    Promise.all([
      this.getBrandList(),
      this.getTableYearList(),
      this.getOrgSupplierCountQuantityFn(),
    ]);
  }

  async getTableYearList() {
    let res: any = await this.queryLastFiveYearsWithMerge();
    this.tableYearList = res;
  }
  async getOrgSupplierCountQuantityFn() {
    let res: any = await this.getOrgSupplierCountQuantity();
    this.totalAmount = res;
  }

  async mounted() {
    this.getData();
  }
  countOrder: any = "";
  sortChangeFn({ column, prop, order }) {
    console.log(order, "--order", order === "ascending");
    if (order === "ascending") {
      // 正序
      this.countOrder = 0;
    } else if (order === "descending") {
      // 倒序
      this.countOrder = 1;
    } else {
      this.countOrder = "";
    }
    (this as any).handlePageChange(1);
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum,
    };

    let searchForm: any = {
      pageInput,
    };
    const { brand, patternList, specification } = this.form;

    if (patternList && patternList.length > 0) {
      searchForm.patternList = patternList;
    }
    if (specification) {
      searchForm.specifications = specification;
    }
    if (brand) {
      searchForm.brand = brand;
    }
    console.log(this.countOrder, "--this.countOrder");
    if (typeof this.countOrder === "number") {
      searchForm.inventorySort = this.countOrder;
    }
    try {
      let { pageInput, ...input } = searchForm;
      this.tableSearchForm = { input };
      let { total, list } = await this.querySupplierCount({
        input,
        pageInput,
      });
      this.dataList = list;

      (this as any).total = total;
    } catch (err) {
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }

  async getBrandList() {
    const { list, total } = await this.queryBrandList({
      pageInput: {
        pageNum: 1,
        pageSize: 100,
      },
      condition: {
        locale: localStorage.getItem("Language") || "zh-CN",
        channel: localStorage.getItem("channel"),
        orgCode: "default",
        conditionList: [[]],
      },
    });
    this.priceBrandList = list.map(({ brandName, brandCode }) => ({
      label: brandName,
      value: brandCode,
    }));
  }

  // async getAttrApi() {
  //   console.log('attrOptionsManager', attrOptionsManager);
  //   this.patternDataList = attrOptionsManager.getPatternOptions();
  //   this.specificationList = attrOptionsManager.getSpecificationOptions();
  //   // this.hubDiameterDataList = this.hubDiameterList;
  //   // this.flattenDataList = this.flattenList;
  //   // this.sectionWidthDataList = this.sectionWidthList;
  // }

  async exportExcelFn() {
    const input = this.tableSearchForm || {};
    return await this.exportSupplierCount(input);
  }
  storePurchaseDisplayDialogVisible: any = false;
  canViewInventory: any = 0;
  async openPurchasePopFn() {
    let res: any = await this.queryStoreViewInventoryStatus({});
    console.log(res);
    this.canViewInventory = Number(res);
    this.storePurchaseDisplayDialogVisible = true;
  }
  async setPurchaseDisplayFn(canViewInventory) {
    await this.updateStoreViewInventoryStatus({
      canViewInventory,
    });

    this.storePurchaseDisplayDialogVisible = false;
    this["$message"].success("设置成功");
  }
}
